import { RouterProvider, createBrowserRouter } from "react-router";
import DevicePage from "../../pages/DevicePage";
import SearchPage from "../../pages/SearchPage";
import InstallationPage from "../../pages/InstallationPage";
import Layout from "../Layout";
import { routes } from "../../utils/routeHelper";
import MainPage from "../../pages/MainPage";
import { useEffect, useMemo } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { useMsal } from "@azure/msal-react";
import DashboardPage from "../../pages/DashboardPage";
import Page404 from "../../pages/404";
import Page403 from "../../pages/403";
import StorePage from "../../pages/StorePage";
import { APP_VERSION } from "../../utils/version";
import AccountPage from "../../pages/AccountPage";
import { useStore } from "../../store/store";

export default function Navigation() {
  const { instance } = useMsal();
  const showAppStoreFeature = useStore.useShowAppStoreFeature();

  useEffect(() => {
    const environment = import.meta.env.VITE_ENVIRONMENT;
    const account = instance.getActiveAccount();

    if (
      account &&
      process.env.NODE_ENV === "production" &&
      !datadogRum.getInternalContext()
    ) {
      datadogRum.init({
        applicationId: "b6a6e1df-b5d8-4756-93d2-a4285bc078c0",
        clientToken: "pubc8b58e2b671c989c1316553efc9a3de0",
        site: "datadoghq.eu",
        service: "iot-core-device-manager",
        env: environment,
        version: APP_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 40,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
        allowedTracingUrls: [
          /^https:\/\/[^/]+\.core\.grundfos\.dev(?:\/|$)/,
          /^wss:\/\/[^/]+\.service\.signalr\.net(?:\/|$)/,
        ],
      });

      datadogRum.setUser({
        id: account?.localAccountId,
        email: account?.idTokenClaims?.signInName as string,
      });
    }
  }, [instance]);

  const router = useMemo(() => {
    const children = [
      {
        path: "/",
        element: <MainPage />,
      },
      {
        path: routes.dashboard.get(),
        element: <DashboardPage />,
      },
      {
        path: routes.installation.get(),
        element: <InstallationPage />,
      },
      {
        path: routes.device.get(),
        element: <DevicePage />,
      },
      {
        path: routes.search.get(),
        element: <SearchPage />,
      },
      {
        path: routes[403].get(),
        element: <Page403 />,
      },
      {
        path: routes.account.get(),
        element: <AccountPage />,
      },
    ];

    if (showAppStoreFeature) {
      children.push({
        path: routes.store.get(),
        element: <StorePage />,
      });
      children.push({
        path: routes.product.get(),
        element: <StorePage />,
      });
    }

    return createBrowserRouter([
      {
        path: "/",
        element: <Layout />,
        children,
      },
      {
        path: routes[404].get(),
        element: <Page404 />,
      },
      {
        path: "*",
        element: <Page404 />,
      },
    ]);
  }, [showAppStoreFeature]);

  return <RouterProvider router={router} />;
}
